import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import type { Locale } from '@/js/libs/dayjs';
import dayjs, { locales } from '@/js/libs/dayjs';

const DayjsInitializer = () => {
  const [, i18n] = useTranslation(['backend', 'common']);

  useEffect(() => {
    const locale = locales[i18n.language as Locale];

    dayjs.locale(locale, { weekStart: 1 });
  }, [i18n.language]);

  return null;
};

export default memo(DayjsInitializer);
